export default __webpack_public_path__ + "static/media/info_cashout.min.5ced9971.png";